import { createStyles, makeStyles } from '@material-ui/styles';

const style = () =>
  createStyles({
    topBar: {
      width: '100%',
      display: 'flex',
      justifyContent: 'flex-end',
      alignItems: 'center',
      padding: '20px'
    },
    container: {
      margin: '20px 100px',
      display: 'flex',
      flexDirection: 'column',
      justifyContent: 'center',
      alignItems: 'center',
      gap: '40px',
      '@media (max-width: 425px)': {
        margin: '20px',
        '&>div>h1': {
          fontSize: '1.5rem'
        }
      },
      '@media (max-width: 325px)': {
        margin: '30px 20px',
        '&>div>h1': {
          fontSize: '1rem'
        }
      }
    },
    buttonsContainer: {
      display: 'flex',
      flexDirection: 'column',
      justifyContent: 'center',
      alignItems: 'center',
      gap: '20px',
      width: '100%'
    },
    buttonsColor: {
      display: 'flex',
      flexDirection: 'column',
      justifyContent: 'center',
      alignItems: 'center',
      gap: '20px',
      width: '100%',
      '&>:nth-child(1)': {
        backgroundColor: 'orange'
      },
      '&>:nth-child(2)': {
        backgroundColor: 'red'
      },
      '&>:nth-child(3)': {
        backgroundColor: '#4B6BDA'
      },
      '&>:nth-child(4)': {
        backgroundColor: 'green'
      },
      '&>:nth-child(5)': {
        backgroundColor: 'blue'
      }
    }
  });

const useStyle = makeStyles(style);
export default useStyle;
